// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XContentForm_XContentForm__khVtC {
  box-shadow: 0px 26px 26px 0px rgba(0, 0, 0, 0.2) inset;
  background-color: #DDDBDB;
  height: 100%;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/X/styles/XContentForm.module.scss"],"names":[],"mappings":"AAAA;EAGI,sDAAA;EACA,yBAAA;EACA,YAAA;EACA,WAAA;AACJ","sourcesContent":[".XContentForm {\n    -webkit-box-shadow: 0px 26px 26px 0px rgba(0, 0, 0, 0.2) inset;\n    -moz-box-shadow: 0px 26px 26px 0px rgba(0, 0, 0, 0.2) inset;\n    box-shadow: 0px 26px 26px 0px rgba(0, 0, 0, 0.2) inset;\n    background-color: #DDDBDB;\n    height: 100%;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XContentForm": `XContentForm_XContentForm__khVtC`
};
export default ___CSS_LOADER_EXPORT___;
